import { combineDateAndTime } from './combineDateAndTime';

export function getFirstOccurrenceEndDate(
  startDate: Date | string,
  endDate: Date | string,
  timeZone?: string
): Date {
  return combineDateAndTime(new Date(startDate), new Date(endDate), timeZone);
}
